import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { I18n } from '@fiverr-private/fiverr_context';
import { DEGREE_TITLES } from './constants';
import { default as countryList } from './countryList.json';

export default function Education({ education }) {
    const {
        degree_title,
        degree,
        school,
        to_year,
        country_code
    } = education;

    const countryObj = _.find(countryList, { code: country_code.toLowerCase() })
        || _.find(countryList, { code: 'a1' });

    return (
        <li>
            <p>{DEGREE_TITLES[degree_title]} - {degree}</p>
            <p className="co-grey-700">
                {school}, {countryObj.value}, <I18n k="user_page_perseus.seller_profile.graduated"/> {to_year}
            </p>
        </li>
    );
}

Education.propTypes = {
    education: PropTypes.shape({
        degree_title: PropTypes.number,
        degree: PropTypes.string,
        school: PropTypes.string,
        to_year: PropTypes.number
    })
};

Education.defaultProps = {
    education: {
        degree_title: 0,
        degree: '',
        school: '',
        to_year: 0
    }
};
